"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnNoUsd = exports.EnNoNok = exports.EnNoDkk = exports.EnNoSek = exports.EnNoEur = void 0;
class EnNoEur {
    constructor() {
        this.locale = "en-no";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n",
        };
    }
}
exports.EnNoEur = EnNoEur;
class EnNoSek {
    constructor() {
        this.locale = "en-no";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "SEK",
            symbol: "SEK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.EnNoSek = EnNoSek;
class EnNoDkk {
    constructor() {
        this.locale = "en-no";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "DKK",
            symbol: "DKK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.EnNoDkk = EnNoDkk;
class EnNoNok {
    constructor() {
        this.locale = "en-no";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "NOK",
            symbol: "NOK",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C",
        };
    }
}
exports.EnNoNok = EnNoNok;
class EnNoUsd {
    constructor() {
        this.locale = "en-no";
        this.dateFormat = {
            short: "yyyy-MM-dd",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n",
        };
    }
}
exports.EnNoUsd = EnNoUsd;
